import React, { useState, useEffect } from 'react';
import LayoutHeader from './components/LayoutHeader';
import LayoutFooter from './components/LayoutFooter';
import AuthLoginModal from './components/AuthLoginModal';
import AdminDashboard from './components/AdminDashboard';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import NewsPage from './pages/NewsPage';
import FaqPage from './pages/FaqPage';
import ContactPage from './pages/ContactPage';
import ShopCartPage from './components/ShopCartPage';
import WhatsAppButton from './components/WhatsAppButton';
import AnimatedBubbles from './components/AnimatedBubbles'; // Importar el componente de burbujas
import ProductDetailModal from './components/ProductDetailModal';
import SobreNosotrosPage from './pages/SobreNosotrosPage';
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const App = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [bannerVideos, setBannerVideos] = useState([]);
  const [bannerLoaded, setBannerLoaded] = useState(false);
  const [bannerText, setBannerText] = useState({});
  const handleNavigate = (page) => {
    setCurrentPage(page);
    window.history.pushState({ page }, '', `#${page}`);
  };
  
useEffect(() => {
  const page = window.location.hash.replace('#', '');
  if (page) setCurrentPage(page);
}, []);

useEffect(() => {
  const onPopState = () => {
    const page = window.location.hash.replace('#', '');
    setCurrentPage(page || 'home');
  };
  window.addEventListener('popstate', onPopState);
  return () => window.removeEventListener('popstate', onPopState);
}, []);

useEffect(() => {
  window.scrollTo(0, 0);
}, [currentPage]);

useEffect(() => {
  // 1. Leer de localStorage si existe (instantáneo)
  const videosLS = JSON.parse(localStorage.getItem("bannerVideos") || "[]");
  const textLS = JSON.parse(localStorage.getItem("bannerText") || "{}");
  if (videosLS.length) setBannerVideos(videosLS);
  if (Object.keys(textLS).length) setBannerText(textLS);
 setBannerLoaded(true); // ¡Ya puedes mostrar el banner!


  // 2. Luego cargar desde Firestore (asíncrono)
async function fetchBanner() {
  const ref = doc(db, "configuracion", "banner");
  const snap = await getDoc(ref);
  if (snap.exists()) {
    const data = snap.data();
    const newVideos = Array.isArray(data.videos) ? data.videos : [];
    const newText = {
      title: data.title || "Explora el Mundo Submarino",
      description: data.description || "",
      buttonText: data.buttonText || "Ver Tienda",
      buttonUrl: data.buttonUrl || "/shop",
    };

    // Solo actualiza SI los videos son distintos a los actuales
    const videosLS = JSON.parse(localStorage.getItem("bannerVideos") || "[]");
    const textLS = JSON.parse(localStorage.getItem("bannerText") || "{}");
    const videosIguales = JSON.stringify(newVideos) === JSON.stringify(videosLS);
    const textosIguales = JSON.stringify(newText) === JSON.stringify(textLS);

    if (!videosIguales) setBannerVideos(newVideos);
    if (!textosIguales) setBannerText(newText);

    // Actualiza localStorage para futuros ingresos
    localStorage.setItem("bannerVideos", JSON.stringify(newVideos));
    localStorage.setItem("bannerText", JSON.stringify(newText));
  }
}
  fetchBanner();
}, []);
const handleViewDetail = (product) => {
  setSelectedProduct(product);
  setShowModal(true);
};

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 'F2') {
        event.preventDefault();
        setIsLoginModalOpen(true);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleLoginSuccess = () => {
    setIsAdminLoggedIn(true);
  };

  const handleLogout = () => {
    setIsAdminLoggedIn(false);
    setCurrentPage('home');
  };

const handleAddToCart = (product, quantity = 1) => {
  setCartItems((prevItems) => {
    const existingItem = prevItems.find((item) => item.id === product.id);
    if (existingItem) {
      return prevItems.map((item) =>
        item.id === product.id ? { ...item, quantity: item.quantity + quantity } : item
      );
    } else {
      return [...prevItems, { ...product, quantity: quantity }];
    }
  });

  // Notificación moderna al agregar (¡ESTO VA ADENTRO!)
  toast.success(
    <>
      <b>¡Producto agregado!</b>
      <div className="text-xs mt-1">{product.name}</div>
    </>,
    {
      icon: "🛒",
      position: "bottom-right",
      autoClose: 1500,
      theme: "colored",
      style: { fontWeight: 500 }
    }
  );
}; // <--- La función termina aquí, no antes
  
  const handleRemoveFromCart = (productId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== productId));
  };

  const handleUpdateQuantity = (productId, newQuantity) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId ? { ...item, quantity: newQuantity } : item
      ).filter(item => item.quantity > 0)
    );
  };

const renderPage = () => {
  if (isAdminLoggedIn) {
    return (
      <AdminDashboard
        onLogout={handleLogout}
        bannerVideos={bannerVideos}
        setBannerVideos={setBannerVideos}
        bannerText={bannerText}
        setBannerText={setBannerText}
      />
    );
  }
    switch (currentPage) {
case 'home':
  return (
<HomePage
  onAddToCart={handleAddToCart}
  onNavigate={handleNavigate}
  bannerVideos={bannerVideos}
  bannerText={bannerText}
  bannerLoaded={bannerLoaded}
/>
  );
case 'shop':
  return (
    <>
      <ShopPage
        onAddToCart={handleAddToCart}
        onViewDetail={handleViewDetail}
      />
      {showModal && (
        <ProductDetailModal
          product={selectedProduct}
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          onAddToCart={handleAddToCart}
        />
      )}
    </>
  );
  case 'sobre-nosotros':
  return <SobreNosotrosPage />;

      case 'news':
        return <NewsPage />;
      case 'faq':
        return <FaqPage />;
      case 'contact':
        return <ContactPage />;
      case 'cart':
        return (
<ShopCartPage
  cartItems={cartItems}
  onRemoveFromCart={handleRemoveFromCart}
  onUpdateQuantity={handleUpdateQuantity}
  onNavigate={handleNavigate}
  clearCart={() => setCartItems([])}
/>
        );
      default:
        return <HomePage onAddToCart={handleAddToCart} />;
    }
  };

  return (
    <div className="relative flex flex-col min-h-screen font-sans text-textPrimary">
      <AnimatedBubbles /> {/* Fondo de burbujas animadas */}
      <div className="relative z-10 flex flex-col min-h-screen"> {/* Contenido principal sobre las burbujas */}
<LayoutHeader onNavigate={handleNavigate} />
<main className="flex-grow pt-20">
          {renderPage()}
        </main>
        <LayoutFooter />
        <ToastContainer
  position="bottom-right"
  autoClose={1700}
  hideProgressBar={false}
  closeOnClick
  pauseOnHover={false}
  draggable={false}
  theme="colored"
/>
        <AuthLoginModal
          isOpen={isLoginModalOpen}
          onClose={() => setIsLoginModalOpen(false)}
          onLoginSuccess={handleLoginSuccess}
        />
        <WhatsAppButton />
      </div>
    </div>
  );
};

export default App;